module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAdklEQVR4AWOgD8hwh6P/GOCcoBocDZSGv/9+X9u3aGpuwP1rFwhr+PPn9+cPD3dNy8izU1g1qen3n18ENPz4/vH4+f2zVk6vr0nft3vN169vCTnp37+nr+6s27d67c5FD5/d+P/vL1Ge/vX9MxCRE0r01zAoAQDgGQECN9P1eAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MX.png
// module id = 1220
// module chunks = 0